# check if we need to support legacy angular
legacySupport = angular.version.major == 1 and angular.version.minor == 0

###*
# RangeSlider, allows user to define a range of values using a slider
# Touch friendly.
# @directive
###

angular.module('siter.io').directive 'rangeSlider', [
  '$document'
  '$filter'
  '$log'
  ($document, $filter, $log) ->
    # test for mouse, pointer or touch
    eventNamespace = '.rangeSlider'
    defaults =
      disabled: false
      orientation: 'horizontal'
      step: 0
      decimalPlaces: 0
      showValues: true
      preventEqualMinMax: false
      attachHandleValues: false
    actions =
      if window.navigator.pointerEnabled
        start: 'pointerdown'
        move: 'pointermove'
        end: 'pointerup'
        over: 'pointerdown'
        out: 'mouseout'
      else if window.navigator.msPointerEnabled
        start: 'MSPointerDown'
        move: 'MSPointerMove'
        end: 'MSPointerUp'
        over: 'MSPointerDown'
        out: 'mouseout'
      else
        start: 'mousedown touchstart'
        move: 'mousemove touchmove'
        end: 'mouseup touchend'
        over: 'mouseover touchstart'
        out: 'mouseout'
    onEvent = actions.start + eventNamespace
    moveEvent = actions.move + eventNamespace
    offEvent = actions.end + eventNamespace
    overEvent = actions.over + eventNamespace
    outEvent = actions.out + eventNamespace

    client = (f) ->
      try
        return [
          f.clientX or f.originalEvent.clientX or f.originalEvent.touches[0].clientX
          f.clientY or f.originalEvent.clientY or f.originalEvent.touches[0].clientY
        ]
      catch e
        return [
          'x'
          'y'
        ]
      return

    restrict = (value) ->
      # normalize so it can't move out of bounds
      if value < 0 then 0 else if value > 100 then 100 else value

    isNumber = (n) ->
      # console.log(n);
      !isNaN(parseFloat(n)) and isFinite(n)

    scopeOptions =
      disabled: '=?'
      min: '='
      max: '='
      modelMin: '=?'
      modelMax: '=?'
      onHandleDown: '&'
      onHandleUp: '&'
      orientation: '@'
      step: '@'
      decimalPlaces: '@'
      filter: '@'
      filterOptions: '@'
      showValues: '@'
      pinHandle: '@'
      preventEqualMinMax: '@'
      attachHandleValues: '@'
      getterSetter: '@'
    if legacySupport
      # make optional properties required
      scopeOptions.disabled = '='
      scopeOptions.modelMin = '='
      scopeOptions.modelMax = '='
    # if (EVENT < 4) {
    #     // some sort of touch has been detected
    #     angular.element('html').addClass('ngrs-touch');
    # } else {
    #     angular.element('html').addClass('ngrs-no-touch');
    # }
    {
      restrict: 'A'
      replace: true
      template: [
        '<div class="ngrs-range-slider">'
        '<div class="ngrs-runner">'
        '<div class="ngrs-handle ngrs-handle-min"><i></i></div>'
        '<div class="ngrs-handle ngrs-handle-max"><i></i></div>'
        '<div class="ngrs-join"></div>'
        '</div>'
        '<div class="ngrs-value-runner">'
        # '<div class="ngrs-value ngrs-value-min" ng-show="showValues"><div>{{filteredModelMin}}</div></div>'
        # '<div class="ngrs-value ngrs-value-max" ng-show="showValues"><div>{{filteredModelMax}}</div></div>'
        '</div>'
        '</div>'
      ].join('')
      scope: scopeOptions
      link: (scope, element, attrs, controller) ->

        ###*
        #  FIND ELEMENTS
        ###

        $slider = angular.element(element)
        handles = [
          element.find('.ngrs-handle-min')
          element.find('.ngrs-handle-max')
        ]
        values = [
          element.find('.ngrs-value-min')
          element.find('.ngrs-value-max')
        ]
        join = element.find('.ngrs-join')
        pos = 'left'
        posOpp = 'right'
        orientation = 0
        allowedRange = [
          0
          0
        ]
        range = 0
        down = false
        # filtered
        # GetterSetters for model values

        modelMin = (newValue) ->
          if scope.getterSetter
            if arguments.length then scope.modelMin(newValue) else scope.modelMin()
          else
            if arguments.length then (scope.modelMin = newValue) else scope.modelMin

        modelMax = (newValue) ->
          if scope.getterSetter
            if arguments.length then scope.modelMax(newValue) else scope.modelMax()
          else
            if arguments.length then (scope.modelMax = newValue) else scope.modelMax

        ###*
        # HANDLE CHANGES
        ###

        setPinHandle = (status) ->
          if status == 'min'
            angular.element(handles[0]).css 'display', 'none'
            angular.element(handles[1]).css 'display', 'block'
          else if status == 'max'
            angular.element(handles[0]).css 'display', 'block'
            angular.element(handles[1]).css 'display', 'none'
          else
            angular.element(handles[0]).css 'display', 'block'
            angular.element(handles[1]).css 'display', 'block'
          return

        setDisabledStatus = (status) ->
          if status
            $slider.addClass 'ngrs-disabled'
          else
            $slider.removeClass 'ngrs-disabled'
          return

        setMinMax = ->
          if scope.min > scope.max
            throwError 'min must be less than or equal to max'
          # only do stuff when both values are ready
          if angular.isDefined(scope.min) and angular.isDefined(scope.max)
            # make sure they are numbers
            if !isNumber(scope.min)
              throwError 'min must be a number'
            if !isNumber(scope.max)
              throwError 'max must be a number'
            range = scope.max - (scope.min)
            allowedRange = [
              scope.min
              scope.max
            ]

            # update models too
            setModelMinMax()
          return

        setModelMinMax = ->
          if modelMin() > modelMax()
            throwWarning 'modelMin must be less than or equal to modelMax'
            # reset values to correct
            modelMin modelMax()
          # only do stuff when both values are ready
          if (angular.isDefined(modelMin()) or scope.pinHandle == 'min') and (angular.isDefined(modelMax()) or scope.pinHandle == 'max')
            # make sure they are numbers
            if !isNumber(modelMin())
              if scope.pinHandle != 'min'
                throwWarning 'modelMin must be a number'
              modelMin scope.min
            if !isNumber(modelMax())
              if scope.pinHandle != 'max'
                throwWarning 'modelMax must be a number'
              modelMax scope.min
            handle1pos = restrict((modelMin() - (scope.min)) / range * 100)
            handle2pos = restrict((modelMax() - (scope.min)) / range * 100)
            value1pos = undefined
            value2pos = undefined
            if scope.attachHandleValues
              value1pos = handle1pos
              value2pos = handle2pos
            # make sure the model values are within the allowed range
            modelMin Math.max(scope.min, modelMin())
            modelMax Math.min(scope.max, modelMax())
            if scope.filter and scope.filterOptions
              scope.filteredModelMin = $filter(scope.filter)(modelMin(), scope.filterOptions)
              scope.filteredModelMax = $filter(scope.filter)(modelMax(), scope.filterOptions)
            else if scope.filter
              filterTokens = scope.filter.split(':')
              filterName = scope.filter.split(':')[0]
              filterOptions = filterTokens.slice().slice(1)
              modelMinOptions = undefined
              modelMaxOptions = undefined
              # properly parse string and number args
              filterOptions = filterOptions.map((arg) ->
                if isNumber(arg)
                  return +arg
                else if arg[0] == '"' and arg[arg.length - 1] == '"' or arg[0] == '\'' and arg[arg.length - 1] == '\''
                  return arg.slice(1, -1)
                return
              )
              modelMinOptions = filterOptions.slice()
              modelMaxOptions = filterOptions.slice()
              modelMinOptions.unshift modelMin()
              modelMaxOptions.unshift modelMax()
              scope.filteredModelMin = $filter(filterName).apply(null, modelMinOptions)
              scope.filteredModelMax = $filter(filterName).apply(null, modelMaxOptions)
            else
              scope.filteredModelMin = modelMin()
              scope.filteredModelMax = modelMax()
            # check for no range
            if scope.min == scope.max and modelMin() == modelMax()
              # reposition handles
              angular.element(handles[0]).css pos, '0%'
              angular.element(handles[1]).css pos, '100%'
              if scope.attachHandleValues
                # reposition values
                angular.element(values[0]).css pos, '0%'
                angular.element(values[1]).css pos, '100%'
              # reposition join
              angular.element(join).css(pos, '0%').css posOpp, '0%'
            else
              # reposition handles
              angular.element(handles[0]).css pos, handle1pos + '%'
              angular.element(handles[1]).css pos, handle2pos + '%'
              if scope.attachHandleValues
                # reposition values
                angular.element(values[0]).css pos, value1pos + '%'
                angular.element(values[1]).css pos, value2pos + '%'
                angular.element(values[1]).css posOpp, 'auto'
              # reposition join
              angular.element(join).css(pos, handle1pos + '%').css posOpp, 100 - handle2pos + '%'
              # ensure min handle can't be hidden behind max handle
              if handle1pos > 95
                angular.element(handles[0]).css 'z-index', 3
          return

        handleMove = (index) ->
          $handle = handles[index]
          # on mousedown / touchstart
          $handle.bind(onEvent + 'X', (event) ->
            handleDownClass = (if index == 0 then 'ngrs-handle-min' else 'ngrs-handle-max') + '-down'
            modelValue = (if index == 0 then modelMin() else modelMax()) - (scope.min)
            originalPosition = modelValue / range * 100
            originalClick = client(event)
            previousClick = originalClick
            previousProposal = false
            if angular.isFunction(scope.onHandleDown)
              scope.onHandleDown()
            # stop user accidentally selecting stuff
            # angular.element('body').bind 'selectstart' + eventNamespace, ->
            #   false
            # only do stuff if we are disabled
            if !scope.disabled
              # flag as down
              down = true
              # add down class
              $handle.addClass 'ngrs-down'
              $slider.addClass 'ngrs-focus ' + handleDownClass
              # add touch class for MS styling
              angular.element('body').addClass 'ngrs-touching'
              # listen for mousemove / touchmove document events
              $document.bind(moveEvent, (e) ->
                # prevent default
                e.preventDefault()
                currentClick = client(e)
                movement = undefined
                proposal = undefined
                other = undefined
                per = scope.step / range * 100
                otherModelPosition = ((if index == 0 then modelMax() else modelMin()) - (scope.min)) / range * 100
                if currentClick[0] == 'x'
                  return
                # calculate deltas
                currentClick[0] -= originalClick[0]
                currentClick[1] -= originalClick[1]
                # has movement occurred on either axis?
                movement = [
                  previousClick[0] != currentClick[0]
                  previousClick[1] != currentClick[1]
                ]
                # propose a movement
                proposal = originalPosition + currentClick[orientation] * 100 / (if orientation then $slider.height() else $slider.width())
                # normalize so it can't move out of bounds
                proposal = restrict(proposal)
                if scope.preventEqualMinMax
                  if per == 0
                    per = 1 / range * 100
                    # restrict to 1
                  if index == 0
                    otherModelPosition = otherModelPosition - per
                  else if index == 1
                    otherModelPosition = otherModelPosition + per
                # check which handle is being moved and add / remove margin
                if index == 0
                  proposal = if proposal > otherModelPosition then otherModelPosition else proposal
                else if index == 1
                  proposal = if proposal < otherModelPosition then otherModelPosition else proposal
                if scope.step > 0
                  # only change if we are within the extremes, otherwise we get strange rounding
                  if proposal < 100 and proposal > 0
                    proposal = Math.round(proposal / per) * per
                if proposal > 95 and index == 0
                  $handle.css 'z-index', 3
                else
                  $handle.css 'z-index', ''
                if movement[orientation] and proposal != previousProposal
                  if index == 0
                    # update model as we slide
                    modelMin parseFloat(parseFloat(proposal * range / 100 + scope.min).toFixed(scope.decimalPlaces))
                  else if index == 1
                    modelMax parseFloat(parseFloat(proposal * range / 100 + scope.min).toFixed(scope.decimalPlaces))
                  # update angular
                  scope.$apply()
                  previousProposal = proposal
                previousClick = currentClick
                return
              ).bind offEvent, ->
                if angular.isFunction(scope.onHandleUp)
                  scope.onHandleUp()
                # unbind listeners
                $document.off moveEvent
                $document.off offEvent
                angular.element('body').removeClass 'ngrs-touching'
                # cancel down flag
                down = false
                # remove down and over class
                $handle.removeClass 'ngrs-down'
                $handle.removeClass 'ngrs-over'
                # remove active class
                $slider.removeClass 'ngrs-focus ' + handleDownClass
                return
            return
          ).on(overEvent, ->
            $handle.addClass 'ngrs-over'
            return
          ).on outEvent, ->
            if !down
              $handle.removeClass 'ngrs-over'
            return
          return

        throwError = (message) ->
          scope.disabled = true
          throw new Error('RangeSlider: ' + message)
          return

        throwWarning = (message) ->
          $log.warn message
          return

        scope.filteredModelMin = modelMin()
        scope.filteredModelMax = modelMax()

        ###*
        #  FALL BACK TO DEFAULTS FOR SOME ATTRIBUTES
        ###

        attrs.$observe 'disabled', (val) ->
          if !angular.isDefined(val)
            scope.disabled = defaults.disabled
          scope.$watch 'disabled', setDisabledStatus
          return
        attrs.$observe 'orientation', (val) ->
          if !angular.isDefined(val)
            scope.orientation = defaults.orientation
          classNames = scope.orientation.split(' ')
          useClass = undefined
          i = 0
          l = classNames.length
          while i < l
            classNames[i] = 'ngrs-' + classNames[i]
            i++
          useClass = classNames.join(' ')
          # add class to element
          $slider.addClass useClass
          # update pos
          if scope.orientation == 'vertical' or scope.orientation == 'vertical left' or scope.orientation == 'vertical right'
            pos = 'top'
            posOpp = 'bottom'
            orientation = 1
          return
        attrs.$observe 'step', (val) ->
          if !angular.isDefined(val)
            scope.step = defaults.step
          return
        attrs.$observe 'decimalPlaces', (val) ->
          if !angular.isDefined(val)
            scope.decimalPlaces = defaults.decimalPlaces
          return
        attrs.$observe 'showValues', (val) ->
          if !angular.isDefined(val)
            scope.showValues = defaults.showValues
          else
            if val == 'false'
              scope.showValues = false
            else
              scope.showValues = true
          return
        attrs.$observe 'pinHandle', (val) ->
          if !angular.isDefined(val)
            scope.pinHandle = null
          else
            if val == 'min' or val == 'max'
              scope.pinHandle = val
            else
              scope.pinHandle = null
          scope.$watch 'pinHandle', setPinHandle
          return
        attrs.$observe 'preventEqualMinMax', (val) ->
          if !angular.isDefined(val)
            scope.preventEqualMinMax = defaults.preventEqualMinMax
          else
            if val == 'false'
              scope.preventEqualMinMax = false
            else
              scope.preventEqualMinMax = true
          return
        attrs.$observe 'attachHandleValues', (val) ->
          if !angular.isDefined(val)
            scope.attachHandleValues = defaults.attachHandleValues
          else
            if val == 'true' or val == ''
              # flag as true
              scope.attachHandleValues = true
              # add class to runner
              element.find('.ngrs-value-runner').addClass 'ngrs-attached-handles'
            else
              scope.attachHandleValues = false
          return
        # listen for changes to values
        scope.$watch 'min', setMinMax
        scope.$watch 'max', setMinMax
        scope.$watch (->
          modelMin()
        ), setModelMinMax
        scope.$watch (->
          modelMax()
        ), setModelMinMax

        ###*
        # DESTROY
        ###

        scope.$on '$destroy', ->
          # unbind event from slider
          $slider.off eventNamespace
          # unbind from body
          angular.element('body').off eventNamespace
          # unbind from document
          $document.off eventNamespace
          # unbind from handles
          i = 0
          l = handles.length
          while i < l
            handles[i].off eventNamespace
            handles[i].off eventNamespace + 'X'
            i++
          return

        ###*
        # INIT
        ###

        # $slider.bind('selectstart' + eventNamespace, (event) ->
        #   false
        # ).bind 'click', (event) ->
        #   event.stopPropagation()
        #   return
        # bind events to each handle
        handleMove 0
        handleMove 1
        return

    }
]
# requestAnimationFramePolyFill
# http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
# shim layer with setTimeout fallback
window.requestAnimFrame = do ->
  window.requestAnimationFrame or window.webkitRequestAnimationFrame or window.mozRequestAnimationFrame or (callback) ->
    window.setTimeout callback, 1000 / 60
    return



// WEBPACK FOOTER //
// ./src/app/common/modules/rangeSlider.module.coffee